// web-v2/src/services/document-list.service.js
//
// THE FIND-IT READS (paperwork-1 D8, L1b-B3): the documents home's lists, each through the one reader on the server
// (routes/document-readers.routes.js). Every row carries its derived name, its class, its policy ({ id, policy_number,
// term_years }) and its tails; a document opens through openStoredDocument (the logged download door), never a link.
// The refusals a screen renders as a sentence are expected (no toast beside them).
import { api } from '@/lib/api.js';

const enc = encodeURIComponent;
const LIST_EXPECTED = [{ status: 409, code: 'NO_POLICY_ROW' }, { status: 404, code: 'ACCOUNT_NOT_FOUND' }, { status: 400, code: 'BAD_REQUEST' }];

export function getAccountDocumentList(idOrSlug) {
  return api.get(`/api/tracon/account/${enc(idOrSlug)}/document-list`, { expected: LIST_EXPECTED });
}
export function getDealDocumentList(dealId) {
  return api.get(`/api/tracon/deals/${enc(dealId)}/documents`, { expected: LIST_EXPECTED });
}
export function getAircraftDocuments(tail) {
  return api.get(`/api/tracon/aircraft/${enc(String(tail || '').trim())}/documents`, { expected: LIST_EXPECTED });
}
// Test data is hidden unless showTest (David 2026-10-31; the search page's Show test toggle): each shown row carries is_test.
export function searchDocuments(q, { showTest = false } = {}) {
  return api.get(`/api/tracon/documents/search?q=${enc(String(q || '').trim())}${showTest ? '&show_test=1' : ''}`);
}

// One policy's label from the row's own policy block, never an id: "TST-0001, 2026-2027", or the term alone.
export function policyLabel(policy) {
  if (!policy) return 'On the account (no policy)';
  const parts = [policy.policy_number || 'No policy number yet', policy.term_years].filter(Boolean);
  return parts.join(', ');
}

// The rows grouped by policy, in the order the server sent them (newest first), the account-level group last.
export function groupByPolicy(rows) {
  const groups = new Map();
  for (const r of rows || []) {
    const key = r.policy ? String(r.policy.id) : '';
    if (!groups.has(key)) groups.set(key, { key, policy: r.policy || null, label: policyLabel(r.policy), rows: [] });
    groups.get(key).rows.push(r);
  }
  return [...groups.values()].sort((a, b) => (a.key === '') - (b.key === ''));
}
